export interface GitLabCommitAuthorOverviewDto {
  strapiId: number;
  name: string;
  email: string;
  automaticAction: AutomaticAction;
}


export interface GitLabCommitOverviewDto {
  strapiId: number;
  hash: string;
  acceptanceStatus: AcceptanceStatus;
  author: GitLabCommitAuthorOverviewDto;
  timeSeen: string;
  commitTime: string;
  message: string;
}


export interface GitLabProjectOverviewDto {
  strapiProjectId: number;
  url: string;
  defaultBranch: string;
  lastCheck: string;
  totalCommits: number;
  nonAcceptedCommits: number;
}

export enum AutomaticAction{
  AUTO_ACCEPT = 'AUTO_ACCEPT',
}

export enum AcceptanceStatus {
  AUTOMATICALLY_ACCEPTED = 'AUTOMATICALLY_ACCEPTED',
  MANUALLY_ACCEPTED = 'MANUALLY_ACCEPTED',
}


export interface Pair<A, B> {
  first: A;
  second: B;
}

export interface GitlabMergeRequest {
  id: number;
  iid: number;
  project_id: number;
  title: string;
  description: string;
  state: string;
  merged_by: GitlabUser;
  merged_at: string;
  closed_by: GitlabUser;
  closed_at: string;
  created_by: GitlabUser;
  created_at: string;
  target_branch: string;
  source_branch: string;
  author: GitlabUser;
  assignee: GitlabUser;
  draft: boolean;
  work_in_progress: boolean;
  merge_when_pipeline_succeeds: boolean;
  merge_status: string;
  sha: string;
  should_remove_source_branch: boolean;
  web_url: string;
  changes_count: string;
  openDiscussions: number | null;
  openDiscussionThreads: Array<GitlabDiscussion> | null;
  squash: boolean;
  head_pipeline: GitlabPipeline;
}

export interface GitlabDiscussion {
  id: string;
  individual_note: boolean;
  notes: Array<GitlabDiscussionNote>;
}

export interface GitlabDiscussionNote {
  id: number;
  type: string;
  body: string;
  author: GitlabUser;
  created_at: string;
  updated_at: string;
  system: boolean;
  resolvable: boolean;
  resolved: boolean;
  resolved_by: GitlabUser;
  position: GitlabDiscussionNotePosition | null;
}

export interface GitlabDiscussionNotePosition {
  new_path: string;
  old_path: string;
  new_line: number | null;
  old_line: number | null;
}

export interface GitlabUser {
  id: number;
  name: string;
  username: string;
  bot: boolean;
}

export interface GitlabMergeRequestIgnoreSettingDto {
  ignore: boolean;
  mrUrl: string;
  reasonId: number;
}

export interface CodeReviewTabWebSocketFromClient {
  reloaded: boolean;
}
export interface CodeReviewTabWebSocketToClient {
  from: string;
}

export interface GitlabPipeline {
  id: number;
  project_id: number;
  status: string;
}


export interface GitlabOpenMergeRequests {
  notMineConfig: Array<GitlabMrAlertIgnoreProjectNotMineDto>;
  completelyOpen: Array<GitlabMrInfoExtended>;
  openButNotMine: Array<GitlabMrInfo>;
  openIgnoredWithoutReason: Array<GitlabMrInfo>;
  openIgnoredWithReason: Array<GitlabMrAlertIgnoreReason>;
  ignoredButNoLongerOpen: Array<GitlabMrAlertIgnoreDto>;
  projectNotMineEntriesNotActuallyIgnoringAnything: Array<GitlabMrAlertIgnoreProjectNotMine>;
}

export interface GitlabMrAlertIgnoreProjectNotMine {
  id: number;
  urlPrefix: string;
}

export interface GitlabMrAlertIgnoreProjectNotMineDto {
  id: number;
  urlPrefix: string;
}

export interface GitlabMrInfo {
  server: string;
  mr: GitlabMergeRequest;
}

export type MergeMrStatus = 'MERGED' | 'SCHEDULED' | 'FAILED';

export interface MergeMrResultDto {
  mrUrl: string;
  status: MergeMrStatus;
  message: string;
}

export interface MergeMrsResultDto {
  mergedCount: number;
  scheduledCount: number;
  failedCount: number;
  results: Array<MergeMrResultDto>;
}

export interface GitlabMrInfoExtended {
  server: string;
  mr: GitlabMergeRequest;
  approval: GitlabMergeRequestApproval;
}

interface GitlabMergeRequestApproval {
  approved_by: GitlabApprover[];
}

interface GitlabApprover {
  user: GitlabUser;
}

export interface GitlabMrAlertIgnoreReason {
  id: number;
  reason: string;
  ignoredMrs: Array<GitlabMrInfo>;
}


export interface GitlabMrAlertIgnoreDto {
  id: number;
  url: string;
  reason: string;
}

export enum AiActionType {
  REVIEW = 'REVIEW',
  FIX_MOCKS_DEPENDENCY_UPDATE = 'FIX_MOCKS_DEPENDENCY_UPDATE',
  FIX = 'FIX',
  ANALYSE_FAILURE = 'ANALYSE_FAILURE',
}

export interface AiAction {
  type: AiActionType;
  mrWebUrl: string;
}

export interface GitlabMrAiActionsEntity {
  id: number;
  type: AiActionType;
  mrWebUrl: string;
  stracliCmdUid: string | null;
}

export interface AiActionSearch {
  mrWebUrl: string;
}
